import React, { useState, useEffect } from "react";
import Header from "components/navigation/Header";
import { Toolbar, Grid, Card, CardContent } from "@material-ui/core";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import Colors from "shared/color";
import { ROUTES_VAR } from "shared/constants";
import { Skeleton } from "@material-ui/lab";
import PaymentDetails from "./components/PaymentDetails";
import RazorpayDetails from "./components/RazorpayDetails";
import { EasebuzzDetails } from "./components/EasebuzzDetails";
import { BankDetails } from "./components/BankDetails";
import { subuserPaymentDetails } from "shared/api/subuser";
import { payuDetails } from "./components/payuDetails";

const components = {
  RAZORPAY: RazorpayDetails,
  BANK_TRANSFER: BankDetails,
  PAYU:payuDetails,
  EASEBUZZ: EasebuzzDetails,
};

const SubuserPaymentView = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    let search = props.match.params.id;
    subuserPaymentDetails(search)
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
      // eslint-disable-next-line
  }, []);

  return (
    <>
      <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <BreadcrumbsHeader
                text={["Subuser Payment", "Payment Details"]}
                links={[ROUTES_VAR.subuserPayments]}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </Header>
      <div className="common_padding_from_title">
        <div className="flex-spacing">
          {!loading &&
          data.success &&
          data["data"]["subuser_payment"] &&
          data["data"]["subuser_payment"]["payment_receipt_mode"] ? (
            <PaymentDetails
              data={data["data"]["subuser_payment"]}
              setData={setData}
              Component={
                // RazorpayDetails
                components[
                  data["data"]["subuser_payment"]["payment_receipt_mode"]
                ]
              }
            />
          ) : !loading ? (
            <Card>
              <CardContent>No Payments Found</CardContent>
            </Card>
          ) : (
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={120}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SubuserPaymentView;
